<template>
  <div class="relative">
    <div
      class="font-inter font-normal text-text-color text-center text-sm px-3 py-2 rounded-md"
      :style="getMediumStyle(notification.email)"
      @mouseover="toggleToolTip"
      @mouseleave="toggleToolTip"
    >
      {{ (notification.email && notification.email.status) || GENERAL_CONSTANTS.NOT_APPLICABLE }}
    </div>
    <UiTooltip
      v-if="showTooltip && notification?.email"
      :title="title"
      :description="description"
    />
  </div>
</template>

<script>
import UiTooltip from '@src/components/UiSelectTooltip.vue'
import { getMediumStyle } from '@src/utils/filters/announcements/index.js'
import DATE_TIME_CONSTANT from '@src/constants/date-time-constants.js'
import GENERAL_CONSTANTS from '@src/constants/general-constants'

export default {
  components: {
    UiTooltip,
  },
  props: {
    notification: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      DATE_TIME_CONSTANT,
      GENERAL_CONSTANTS,
      showTooltip: false,
    }
  },
  computed: {
    title() {
      if (this.notification?.webpush?.status === 'sent') {
        return 'successfully sent'
      } else if (this.notification?.email?.failed_reason) {
        return this.notification.email.failed_reason
      }
      return 'reason not found'
    },
    description() {
      if (this.notification?.email?.last_attempted_at) {
        return this.$filters.formattedDate(
          this.notification.email.last_attempted_at,
          DATE_TIME_CONSTANT.DATE_TIME_12,
        )
      }
      return 'time not found'
    },
  },
  methods: {
    getMediumStyle,
    toggleToolTip() {
      this.showTooltip = !this.showTooltip
    },
  },
}
</script>
